<template>
    <div class="layout-topbar">
        <div class="layout-topbar-icons">
            <AppProfile />
        </div>
    </div>
</template>

<script>
import AppProfile from "./AppProfile.vue";

export default {
    components: {
        AppProfile: AppProfile,
    },
    methods: {
        onMenuToggle(event) {
            this.$emit("menu-toggle", event);
        },
    },
};
</script>

<style lang="scss" scoped>

.o-m-0 {
    margin: 0px;
}

.o-mr-2 {
    margin-right: 10px;
}
</style>